import type { AdminSkill } from '@/api';

function ioSummary(s: AdminSkill): string {
  const inn = s.inputs?.length ?? 0;
  const out = s.outputs?.length ?? 0;
  if (inn === 0 && out === 0) return 'no I/O';
  return `in ${inn} / out ${out}`;
}

export default function SkillsTable({
  skills,
  onSelect,
}: {
  skills: AdminSkill[];
  onSelect: (s: AdminSkill) => void;
}) {
  return (
    <div className="bg-surface border border-border rounded-xl overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-texts border-b border-border">
              <th className="font-medium px-4 py-3">Skill</th>
              <th className="font-medium px-4 py-3">Category</th>
              <th className="font-medium px-4 py-3">Discipline</th>
              <th className="font-medium px-4 py-3">Source</th>
              <th className="font-medium px-4 py-3">Status</th>
              <th className="font-medium px-4 py-3">I/O</th>
              <th className="font-medium px-4 py-3">Concepts</th>
            </tr>
          </thead>
          <tbody>
            {skills.map((s) => (
              <tr
                key={s.id}
                className="border-b border-border last:border-b-0 hover:bg-surface2 transition-colors"
              >
                <td className="px-4 py-3">
                  <button onClick={() => onSelect(s)} className="text-left min-w-0">
                    <span className="block text-textp font-medium truncate">{s.name}</span>
                    <span className="block text-xs text-texts truncate">{s.id}</span>
                  </button>
                </td>
                <td className="px-4 py-3 text-texts truncate max-w-[12rem]">{s.category || '—'}</td>
                <td className="px-4 py-3 text-texts truncate max-w-[12rem]">{s.discipline || '—'}</td>
                <td className="px-4 py-3 text-texts truncate max-w-[12rem]">{s.source || '—'}</td>
                <td className="px-4 py-3">
                  <span
                    className={`whitespace-nowrap inline-flex items-center gap-1.5 text-xs ${
                      s.active ? 'text-success' : 'text-texts'
                    }`}
                  >
                    <i className={s.active ? 'ri-checkbox-circle-line' : 'ri-forbid-line'} />
                    {s.active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="px-4 py-3 font-mono text-texts">{ioSummary(s)}</td>
                <td className="px-4 py-3 text-texts truncate max-w-[16rem]">
                  {(s.concepts || []).join(', ') || '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
